// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3807":"616cfff8e5bfce74","7371":"f45199d73c35c8c8","7953":"a72fd2156c345a06","8827":"317f5e9cb18b3cc5"}[chunkId] + ".css";
};